<template>
  <div class="header">
    <div class="header--left">
      <div class="header-icon--wrapper">
        <span class="header-icon" uk-icon="icon: user; ratio: 1.1"></span>
      </div>
      <div class="header-info">
        <div class="header-title">
          {{ this.$store.state.auth.user != null ? this.$store.state.auth.user.username : '' }}
        </div>
        <div class="header-subtitle">
          {{ this.$store.state.auth.user != null ? this.$store.state.auth.user.phone : '' }}
        </div>
      </div>
    </div>
    <div class="header--right">
      <!--      <span class="right-menu-icon" uk-icon="icon: message; ratio: 1.5"></span>-->
      <span class="right-menu-icon" uk-icon="icon: close; ratio: 1.5;" @click="toggleMenu"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DesktopRightMenuOpenedHeader',
  methods: {
    toggleMenu() {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped></style>
